import axiosInstance from '../helpers/axios';
export const handleExcelDownload = ({
  status,
  instituteId,
  fromDate,
  toDate,
  productType,
  user,
  downloadIcon,
  buttonId = 'downloadButton',
  buttonStyles = {},
  additionalData = {}
}) => {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = String(currentDate.getFullYear());
  const formattedDate = `${day}-${month}-${year}`;

  const downloadButton = document.getElementById(buttonId);
  if (!downloadButton) {
    console.error(`Button with id "${buttonId}" not found`);
    return;
  }

  downloadButton.disabled = true;
  downloadButton.innerText = "Wait....";
  downloadButton.style.backgroundColor = "#D22129";
  downloadButton.style.color = "white";
  downloadButton.style.fontFamily = "Inter-Medium";
  downloadButton.style.fontSize = "15px";
  downloadButton.style.width = buttonStyles.width || "90px";
  downloadButton.style.cursor = "pointer";
  downloadButton.style.height = "34px";
  downloadButton.style.borderRadius = "5px";
  downloadButton.style.textAlign = "center";
  downloadButton.style.marginLeft = buttonStyles.marginLeft || "150px";
  downloadButton.style.backgroundImage = "none";

  const downloadTemplateUrl = `/excel/download`;
  const downloadData = {
    instituteId: instituteId || null,
    status: status,
    fromDate: fromDate || null,
    toDate: toDate ? `${toDate} 23:59:59` : null,
    productType: productType || null,
    ...additionalData
  };

  axiosInstance.post(downloadTemplateUrl, downloadData, {
    responseType: 'arraybuffer',
    headers: {
    }
  }).then((res) => {
    if(res.status === 200){
     setTimeout(() => {
      downloadButton.disabled = false;
      downloadButton.innerText = "Export";
      downloadButton.style.paddingLeft = "30px";
      downloadButton.style.backgroundColor = "#D22129";
      downloadButton.style.color = "white";
      downloadButton.style.fontFamily = "Inter-Medium";
      downloadButton.style.fontSize = "15px";
      downloadButton.style.width = buttonStyles.width || "90px";
      downloadButton.style.cursor = "pointer";
      downloadButton.style.height = "34px";
      downloadButton.style.borderRadius = "5px";
      downloadButton.style.textAlign = "center";
      downloadButton.style.marginLeft = buttonStyles.marginLeft || "150px";
      downloadButton.style.backgroundImage = `url(${downloadIcon})`;
      downloadButton.style.backgroundRepeat = 'no-repeat';
      downloadButton.style.backgroundSize = '15px';
      downloadButton.style.backgroundPosition = '10px 10px';
    }, 2000);
    alert("Report generated. You will receive it on your email shortly.");
    window.location.reload()
    }
   

    // Create and trigger download
    // const blob = new Blob([res.data], { type: "application/xlsx" });
    // const url = window.URL.createObjectURL(blob);
    // const link = document.createElement('a');
    // link.href = url;
    // link.download = `${formattedDate}_${status}.xlsx`;

    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    // window.URL.revokeObjectURL(url);
  }).catch((error) => {
    alert("Error Downloading");
    downloadButton.innerText = "Error..";
    downloadButton.style.backgroundColor = "#D22129";
    
    setTimeout(() => {
      downloadButton.disabled = false;
      downloadButton.innerText = "Export";
      downloadButton.style.paddingLeft = "30px";
      downloadButton.style.backgroundColor = "#D22129";
      downloadButton.style.color = "white";
      downloadButton.style.fontFamily = "Inter-Medium";
      downloadButton.style.fontSize = "15px";
      downloadButton.style.width = buttonStyles.width || "90px";
      downloadButton.style.cursor = "pointer";
      downloadButton.style.height = "34px";
      downloadButton.style.borderRadius = "5px";
      downloadButton.style.textAlign = "center";
      downloadButton.style.marginLeft = buttonStyles.marginLeft || "150px";
      downloadButton.style.backgroundImage = `url(${downloadIcon})`;
      downloadButton.style.backgroundRepeat = 'no-repeat';
      downloadButton.style.backgroundSize = '15px';
      downloadButton.style.backgroundPosition = '10px 10px';
    }, 1000);
  });
};


